const hsluvorg = require('hsluv');
const culori = require('culori');
//const csscolornames = require('css-color-names');



// Add hsluv color space to culori....
culori.defineMode({
  mode: 'hsluv',
  output: {
    rgb: (culoriObject) => {
      const o = {mode: 'rgb'};
      const conversion = hsluvorg.hsluvToRgb([culoriObject.h, culoriObject.s, culoriObject.l]);
      o.r = conversion[0];
      o.g = conversion[1];
      o.b = conversion[2];
      return o;
    },
    hex: (culoriObject) => {
      return hsluvorg.hsluvToHex([culoriObject.h, culoriObject.s, culoriObject.l]);
    }
  },
  input: {
    // rgb: hsluvorg.hsluvToRgb
    rgb: (culoriObject) => {
      const o = {mode: 'hsluv'};
      const conversion  = hsluvorg.rgbToHsluv([culoriObject.r, culoriObject.g, culoriObject.b]);
        o.h = conversion[0].toFixed(2);
        o.s = conversion[1].toFixed(2);
        o.l = conversion[2].toFixed(2);
      return o;
    },
    hex: (culoriObject) => {
      const o = {mode: 'hsluv'};
      const conversion = hsluvorg.hexToHsluv(culoriObject);
        o.h = conversion[0].toFixed(2);
        o.s = conversion[1].toFixed(2);
        o.l = conversion[2].toFixed(2);
      return o;
    }
  },
  channels: ['h', 's', 'l'],
  ranges: {
    h: [0, 360],
    s: [0, 100],
    l: [0, 100]
  }
});

const colorHelper = culori;

export default colorHelper;

// const lightnessSteps = [96,88,80,73,65,57,49,41,34,26,18];
// const lightnessSteps = [95,86,77,68,59,49,40,31,22,13];
// const lightnessSteps = [96, 89, 80, 69.5, 58.5, 47, 35, 24, 14, 6];
// const lightnessSteps = [97, 89, 80, 69.5, 58.5, 47, 37, 28, 20, 13];
// main --> const lightnessSteps = [97, 90, 82, 72, 61.5, 47.5, 37, 28, 20, 13];
